<script>
export default {
    name: "IconTruck15"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 24">
        <path
            d="M48.9 17c-.2-1.4-.8-1.8-3-3-1.5-.8-4-3.6-5-5-1.3-2-6-4-6-4H29l-1 1v12h-1V0H0v18l1 2h9s.8-3 4-3 4 2 4 2v2h9v-1h2v1h8s-.4-3.7 4-4c4.1-.2 4 4 4 4h3c-.1 0 1.1-2.5.9-4"/>
        <circle cx="40.9" cy="21" r="3"/>
        <circle cx="14" cy="21" r="3"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
